module.exports = __webpack_public_path__ + "img/wlogo.cff3fa8c.svg";